import React from 'react'
import './rejectedUi.scss'

const RejectedUi = ({ type, title, description , className }) => {
    return (
        // admin_status
        <div className={`${type , className} verification_status`}>
            <div className="wrap">
                {title && <h2 className={`text_md ${description ? '' : 'mb-0'}`}>{title}</h2>}
                {description && <p className='md'>{description}</p>}
            </div>
        </div>
    )
}

export default RejectedUi